import styled from 'styled-components'

export const Consumption = ({
  colorMode,
  data,
}: {
  colorMode: 'dark' | 'light' | undefined
  data: { label: string; value: number; unit: string; color: string }[]
}) => {
  return (
    <ConsumptionRoot>
      {data.map((element) => {
        return <Bar colorMode={colorMode} data={element} />
      })}
    </ConsumptionRoot>
  )
}

const Bar = ({
  colorMode,
  data,
}: {
  colorMode: 'dark' | 'light' | undefined
  data: { label: string; value: number; unit: string; color: string }
}) => {
  const { label, value, unit, color } = data
  const max = 8
  const width = (value / max) * 100
  return (
    <BarRoot
      style={{
        borderBottom:
          colorMode === 'dark'
            ? '1px solid var(--gray-2)'
            : '1px solid var(--gray-4)',
      }}
    >
      <Label>
        <div>{label}</div>
      </Label>
      <BarInner>
        <BarSize style={{ width: width + '%', backgroundColor: color }}>
          {value >= 1 && (
            <>
              {value.toLocaleString("de-CH").replace(".", ",")}
              {unit}
            </>
          )}
          {value <= 5 && <>&nbsp;</>}
        </BarSize>
      </BarInner>
    </BarRoot>
  )
}
const BarRoot = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 15px;
  padding-top: 2px;
  padding-bottom: 2px;
`

const BarInner = styled.div`
  flex: 1 1 auto;
`

const BarSize = styled.div`
  text-align: right;
  padding-right: 5px;
  color: var(--site-background);    font-size: 12px;
`
const Label = styled.div`
  flex: 0 0 150px;
  display: flex;

  @media only screen and (max-width: 711px) {
    flex: 0 0 110px;
  }
  img {
    flex: 0 0 40px;
    max-width: 40px;
  }
  div {
    flex: 1 1 auto;
    line-height: 1.2em;
    span {
      display: inline-block;
      width: 100%;
      font-weight: 700;
    }
  }
`

const ConsumptionRoot = styled.div`
  width: 100%;  margin-bottom: 15px;

`
